import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=10e2c6f0&scoped=true&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2c6f0",
  null
  
)

export default component.exports
import {QBtn,QIcon,QDialog,QCard,QCardSection,QSpace,QSeparator,QTooltip,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QIcon,QDialog,QCard,QCardSection,QSpace,QSeparator,QTooltip}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
